export default __webpack_public_path__ + "static/media/alert-circle.96d18cf3.svg";